import { createSelector } from 'reselect';

export const custodianSelector = (state) => state.custodians;

export const selectCustodians = createSelector(
  custodianSelector,
  (state) => state.Custodians,
);

export const selectCustodian = createSelector(
  custodianSelector,
  (state) => state.Custodian,
);
